import { call, put } from 'redux-saga/effects';
import { ACTIONS, APIS } from '../../_config';
import { CallApi } from '../api/callApi';
 
export function* getStockAdjustmentCode(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.STOCK_ADJUSTMENT.GET_ID, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* getStockAdjustmentByID(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.STOCK_ADJUSTMENT.GET_BY_ID, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* getStockAdjustmentList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.STOCK_ADJUSTMENT.LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* saveStockAdjustmentList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.STOCK_ADJUSTMENT.SAVE, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* deleteStockAdjustmentList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.DELETE, APIS.STOCK_ADJUSTMENT.DELETE + "?StockAdjustmentID=" + data.StockAdjustmentID, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* exportToPdf(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.STOCK_ADJUSTMENT.EXPORT_TO_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* exportToXls(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.STOCK_ADJUSTMENT.EXPORT_TO_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* ExportQRCode(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.STOCK_ADJUSTMENT.EXPORT_QR_CODE, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* MoveStock(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.STOCK_ADJUSTMENT.MOVE_STOCK, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetStockTransactionReport(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.STOCK_ADJUSTMENT.GET_STOCK_TRANSACTION_REPORT, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportStockTransactionReportXls(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.STOCK_ADJUSTMENT.EXPORT_STOCK_TRANSACTION_REPORT_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetStockAdjustmentReport(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.STOCK_ADJUSTMENT.GET_STOCK_ADJUSTMENT_REPORT, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportStockAdjustmentReportXls(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.STOCK_ADJUSTMENT.EXPORT_STOCK_ADJUSTMENT_REPORT_XLS, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ExportStockAdjustmentReportPdf(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.STOCK_ADJUSTMENT.EXPORT_STOCK_ADJUSTMENT_REPORT_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}







